/** Founding Source */
export const CREATE_RESOURCE = 'CREATE_RESOURCE';
export const EDIT_RESOURCE = 'EDIT_RESOURCE';
export const GET_RESOURCE = 'GET_RESOURCE';
export const GET_RESOURCE_SUCCESS = 'GET_RESOURCE_SUCCESS';
export const GET_RESOURCE_BY_ID = 'GET_RESOURCE_BY_ID';
export const GET_RESOURCE_BY_ID_SUCCESS = 'GET_RESOURCE_BY_ID_SUCCESS';
export const CHANGE_RESOURCE_STATUS = 'CHANGE_RESOURCE_STATUS';
export const DELETE_RESOURCE = 'DELETE_RESOURCE';

/** Resource Documents */
export const UPLOAD_RESOURCE_DOCUMENT = 'UPLOAD_RESOURCE_DOCUMENT';
export const EDIT_RESOURCE_DOCUMENT = 'EDIT_RESOURCE_DOCUMENT';
export const GET_RESOURCE_DOCUMENT = 'GET_RESOURCE_DOCUMENT';
export const GET_RESOURCE_DOCUMENT_SUCCESS = 'GET_RESOURCE_DOCUMENT_SUCCESS';
export const DELETE_RESOURCE_DOCUMENT = 'DELETE_RESOURCE_DOCUMENT';

/** Resource Access */
export const EDIT_RESOURCE_ACCESS = 'EDIT_RESOURCE_ACCESS';
export const GET_RESOURCE_ACCESS = 'GET_RESOURCE_ACCESS';
export const GET_RESOURCE_ACCESS_SUCCESS = 'GET_RESOURCE_ACCESS_SUCCESS';
